<div id="wait" *ngIf="isLoading == 1">
    <mat-spinner></mat-spinner>
</div>
<app-meal-member-basic-details [memberDetail]="memberId" [mealPlanMeta]="mealPlanMeta"></app-meal-member-basic-details>
<div class="row" *ngIf="flow == 0">
    <img class="imgBack" (click)="backBtn()" src="assets/img/backbtn.png" />
</div>
<div [ngClass]="{
  'leftSection': mode == 1,
  'leftSection1': mode == 0 }">
    <div class="row mt-5" *ngIf="planDetails.length < 1 && isLoading == 2 && error == 0">
        <div class="col notFound">
            <p>Meal plan not found</p>
        </div>
    </div>
    <div class="row" *ngIf="planDetails.length > 0 && mode == 1">
        <div class="col-md-10"></div>
        <div class="col-md-2 assignBtnDiv">
            <button class="btn tabContent1"
                    (click)="assignOrWarnFromEdit()">
                Assign Meal Plan
            </button>
        </div>
    </div>
    <div *ngFor="let plan of planDetails;let i = index;">
        <div class="row mt-5 ml-1">
            <div class="col">
                <p class="dt">{{plan.day}}
            </div>
            <div class="col textAlign " *ngIf="mode == 1">
                <div class="fastBtnDiv">
                    <button class="btn tabContent" (click)="openFastingModal(i, plan.date, plan.day,null)">Add Fasting
                        Window
                    </button>
                </div>
            </div>
        </div>
        <ng-container *ngFor="let item of getTimelineItems(plan)">
            <!-- Fasting card (shown at its fromTime position in the timeline) -->
            <div *ngIf="item.type === 'fasting' && item.fasting">
                <div class="col mt-3">
                    <p class="dt1">Fasting</p>
                </div>
                <div class="row">
                    <div [ngClass]="{'col-sm-4 mt-1': mode == 0,'col-sm-6 mt-1': mode == 1 }">
                        <div class="tileFast">
                            <div class="row">
                                <div class="col-2">
                                    <img width="60" src="/assets/img/fastingIcon.png" />
                                </div>
                                <div class="col-6"></div>
                                <div class="col-md-4" *ngIf="mode == 1">
                                    <img class="editImg" src="assets/img/edit.png" title="Edit" (click)="openFastingModal(i, plan.date, plan.day, item.fasting)" />
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-md-12">
                                    <div class="col"><span class="dt1">From:</span>&nbsp;&nbsp;<span
                                            class="dt2">{{item.fasting.fromTime}}</span> </div>
                                </div>
                                <div class="col-md-12 mt-2">
                                    <div class="col"><span class="dt1">To:</span>&nbsp;&nbsp;<span
                                            class="dt2">{{item.fasting.toTime}}</span></div>
                                </div>
                                <div class="col-md-12 mt-2">
                                    <div class="col"><span class="dt1">Duration:</span>&nbsp;&nbsp;<span
                                            class="dt2">{{convertSecondsToHoursAndMinutes(item.fasting.duration)}}</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Meal card (shown at its mealTime position in the timeline) -->
            <div *ngIf="item.type === 'meal' && item.meal">
            <div class="col mt-3">
                <p class="dt1">
                    {{item.meal.mealType}}, Time : {{item.meal.mealTime}}
                    <img *ngIf="mode == 1" class="editImg1" src="assets/img/edit.png" (click)="openEditMealModal(item.meal, plan.day)" />
                    <img *ngIf="mode == 1"
                         style="margin-left: 15px;width: 25px; cursor: pointer;"
                         (click)="deleteMeal(plan, item.meal)"
                         src="assets/img/del.png" />
                </p>
            </div>
            <div class="row">
                <div [class]="getRecipeColClass(getAllMealRecipeCards(item.meal).length)"
                    *ngFor="let rec of getAllMealRecipeCards(item.meal)">
                    <div class="tiles mt-2">
                        <div class="row">
                            <div class="meal-type-col" [ngClass]="{'col-md-7': mode == 1,'col-md-9': mode == 0 }">
                                <div class="pack" *ngIf="rec.recipeType == 'Packaged'">
                                    <p style="padding: 10px;">Packaged Food</p>
                                </div>
                                <div class="rest" *ngIf="rec.recipeType == 'Restaurant'">
                                    <p style="padding: 10px;">Restaurant Food</p>
                                </div>
                                <div class="diy" *ngIf="rec.recipeType == 'DIY' || rec.recipeType == 'FreshProduce'">
                                    <p style="padding: 10px;">Do It Yourself</p>
                                </div>
                            </div>
                            <div class="meal-actions-col" [ngClass]="{'col-md-5': mode == 1,'col-md-3': mode == 0 }">
                                <div *ngIf="mode == 1" class="meal-card-actions">
                                    <img class="editImg" src="assets/img/edit.png" title="Edit" (click)="viewEditRecipe(plan,item.meal,rec)" />
                                    <input
                                        type="checkbox"
                                        class="selectCheckbox"
                                        [checked]="isRecipeSelected(item.meal.mealId, rec.recipeId)"
                                        (change)="selectImg(item.meal.mealId, rec.recipeId, $any($event.target).checked, 'recipe')"
                                    />
                                    <img class="deleteImg" (click)="deleteRecipe(item.meal.mealId, rec.recipeId, plan.day)" src="assets/img/del.png" />
                                </div>
                                <div *ngIf="mode == 0">
                                    <img class="editImg" src="assets/img/view.png" /><label class="editLabel"
                                        (click)="viewEditRecipe(plan,item.meal,rec)">View</label>
                                </div>
                            </div>
                        </div>
                        <div class="row align-items-center recipeNameRow">
                            <div class="recipeThumbCol" *ngIf="rec.imageUrl">
                                <img class="recipeThumb" [src]="rec.imageUrl" [alt]="rec.recipeName" (click)="showRecipeImageModal(rec.imageUrl)" />
                            </div>
                            <div class="col mealName">{{rec.recipeName}}</div>
                        </div>
                        <div class="row mt-3">
                            <div class="col recDetails"><span>{{rec.measurement.value}}
                                    {{rec.measurement.unit}}</span>&nbsp;<span><img width="10"
                                        src="assets/img/calories.png" /> </span>&nbsp;<span>{{computeCalories(rec.nutrition.protein, rec.nutrition.carbs, rec.nutrition.fat, rec.nutrition.alcoholGrams)}}
                                    Kcal</span>
                                &nbsp;<span><img width="8"
                                        src="assets/img/protien-old.png" /></span>&nbsp;<span>{{round2(rec.nutrition.protein)}}
                                    g of Protein</span>
                                &nbsp;<span><img width="10"
                                        src="assets/img/carbs.png" /></span>&nbsp;<span>{{round2(rec.nutrition.carbs)}} g of
                                    Carbs</span>
                                &nbsp;<span><img width="10"
                                        src="assets/img/fat.png" /></span>&nbsp;<span>{{round2(rec.nutrition.fat)}} g of
                                    Fats</span>
                            </div>
                        </div>
                        <div class="row mt-4" *ngIf="rec.restaurantRecipeData != null">
                            <div class="col-lg-6" [ngClass]="{'ingrDetails1': i % 2 === 0, 'ingrDetails': i % 2 !== 0}"
                                *ngFor="let ingr of rec.restaurantRecipeData.ingredients; let i = index">
                                {{ingr.ingredientName}} ({{ingr.measurement.quantity}} {{ingr.measurement.unit}})
                            </div>
                        </div>
                        <div class="row mt-4" *ngIf="rec.packagedRecipeData != null">
                            <div class="col-lg-6" [ngClass]="{'ingrDetails1': i % 2 === 0, 'ingrDetails': i % 2 !== 0}"
                                *ngFor="let ingr of rec.packagedRecipeData.ingredients; let i = index">
                                {{ingr.ingredientName}} ({{ingr.measurement.quantity}} {{ingr.measurement.unit}})
                            </div>
                        </div>
                        <div class="row mt-4" *ngIf="rec.diyRecipeData != null">
                            <div class="col-lg-6" [ngClass]="{'ingrDetails1': i % 2 === 0, 'ingrDetails': i % 2 !== 0}"
                                *ngFor="let ingr of rec.diyRecipeData.ingredients; let i = index">
                                {{ingr.ingredientName}} ({{ingr.measurement.quantity}} {{ingr.measurement.unit}})
                            </div>
                        </div>
                        <div class="row mt-4" *ngIf="rec.packagedRecipeData != null">
                            <div class="col-md-7"></div>
                            <div class="col-md-5 restDetails1" *ngIf="rec.packagedRecipeData.stores?.length > 0">
                                Available in <span *ngFor="let item of rec.packagedRecipeData.stores">
                                    {{item.storeName}}
                                </span>
                            </div>
                        </div>

                        <div class="row mt-3" *ngIf="rec.restaurantRecipeData != null">
                            <div class="col resCollapse">Restaurant Details &nbsp;<img width="13"
                                    (click)="changeImg(rec.recipeId+item.meal.mealId)" id={{rec.recipeId+item.meal.mealId}}
                                    src="assets/img/down1.png" />
                            </div>
                        </div>
                        <div class="collapse" id="{{rec.recipeId+item.meal.mealId+'col'}}"
                            *ngIf="rec.restaurantRecipeData != null">
                            <div class="card card-body colapse">
                                <div class="row">
                                    <div class="col">
                                        <span class="restDetails">Name:</span> &nbsp;<span
                                            class="restDetails1">{{rec.restaurantRecipeData.restaurantName}}</span><br />
                                        <span class="restDetails">Address:</span> &nbsp;<span
                                            class="restDetails1">{{rec.restaurantRecipeData.location}}</span><br />
                                        <span class="restDetails">Phone:</span> &nbsp;<span
                                            class="restDetails1">{{rec.restaurantRecipeData.phoneNumber}}</span><br />
                                        <span class="restDetails"
                                            *ngIf="rec.restaurantRecipeData.website!='' && rec.restaurantRecipeData.website!=null">
                                            <a href="{{rec.restaurantRecipeData.website}}"
                                                target="_blank">Website</a></span> &nbsp;&nbsp;<span class="restDetails"
                                            *ngIf="rec.restaurantRecipeData.mapGeoLocation!='' && rec.restaurantRecipeData.mapGeoLocation!=null
                                                 && rec.restaurantRecipeData.mapGeoLocation.indexOf('http') >= 0"><a
                                                href="{{rec.restaurantRecipeData.mapGeoLocation}}" target="_blank">Map</a></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </ng-container>
    </div>
</div>

<!-- Recipe image preview modal -->
<div class="modal fade" id="recipeImageModal" tabindex="-1" role="dialog" aria-labelledby="recipeImageModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content modal-size-style radius">
            <div class="modal-header">
                <h5 class="modal-title">Recipe Image</h5>
                <button type="button" class="close" aria-label="Close" (click)="closeRecipeImageModal()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body textCenter padding">
                <img width="100%" id="recipeModalImg" [src]="" />
            </div>
        </div>
    </div>
</div>

<!-- Confirm assign meal plan modal (edit page) -->
<div class="modal fade" id="confirmAssignMealPlan" tabindex="-1" role="dialog" aria-labelledby="confirmAssignMealPlanLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content modal-size-style radius">
            <div class="modal-header text-center">
                <span class="title1 w-100">Confirm Assign</span>
                <button type="button" class="close" aria-label="Close" (click)="closeConfirmAssignMealPlan()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body textCenter padding">
                <p class="modalText">Do you want to assign this meal plan to the member?</p>
                <br />
                <span><button class="btnConfirm btnLabel" (click)="proceedAssignMealPlan()">Confirm</button></span><span>
                    <button class="btnConfirm1 btnLabel1" (click)="closeConfirmAssignMealPlan()">Cancel</button></span>
            </div>
        </div>
    </div>
</div>

<div style="width:30%;float: left;height: 580px;" *ngIf="mode==1">
    <div class="col chatMainDiv" *ngIf="showHideChatBot">
        <div class="row">
            <div class="col">
                <label class="aiHeader">Meal Plan Co-pilot</label>
            </div>
            <div class="col">
                <img width="20" (click)="hideChatBot()" src="assets/img/close.png" class="chatHide" />
            </div>
        </div>

        <div class="row" style="height: 465px;">
            <div class="col-md-12" style="height: 410px; overflow-y: auto;">

                <div *ngFor="let message of messages" class="message">
                    <div class="message-content"
                        [ngClass]="{ 'user': message.sender === 'user', 'bot': message.sender === 'assistant' }">

                        <strong>{{ message.sender === 'user' ? 'You: ' : 'Bot: ' }}</strong>
                        <span id={{message.id}}>{{ message.text }}</span>
                    </div>
                </div>

            </div>
            <div class="col-md-12" style="height: 50px;border-radius: 15px;border: 1px solid #d5d5d5;">
                <input type="text" [(ngModel)]="userMessage" (keyup.enter)="sendMessage()"
                    class="form-control botInput " placeholder="Type here" />
                &nbsp;&nbsp;<img width="40" src="assets/img/send.png" (click)="sendMessage()"
                    style="margin-top: 5px;" />
            </div>
        </div>
    </div>
    <div class="col"><img class="chatBotBtn" width="60" (click)="openChatBot()" src="assets/img/ai.png" /></div>
</div>

<div class="modal fade" id="confirmAssign" tabindex="-1" role="dialog" aria-labelledby="confirmAssignLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content modal-size-style radius">
            <div class="modal-header text-center">
                <span class="title1  w-100">Meal plan already Exist!</span>
                <button type="button" class="close" aria-label="Close" data-bs-dismiss="modal">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body textCenter padding">
                <p class="modalText">You already have an active meal plan for the selected date.
                    Would you like to remove or change the date for the existing meal
                    plan?</p>
                <br />
                <span><button class="btnConfirm btnLabel" (click)="showcheckAssign()">Yes,
                        Update the existing meal plan</button></span><span>
                    <button class="btnConfirm1 btnLabel1" (click)="closeConfirmAssign()">No,
                        Keep the existing meal plan</button> </span>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="deleteRecipeModal" tabindex="-1" role="dialog" aria-labelledby="deleteRecipeModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content modal-size-style radius">
            <div class="modal-header">
                <span class="title1  w-100">Please confirm!</span>
                <button type="button" class="close" aria-label="Close" data-bs-dismiss="modal">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body textCenter padding">
                <p class="modalText">Are you sure you want to delete this recipe?</p>
                <br />
                <span><button class="btnConfirm btnLabel" (click)="proceedDelRecipe()">Proceed</button></span><span>
                    <button class="btnConfirm1 btnLabel1" (click)="closeDelRecipe()">Cancel</button> </span>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="deleteMealModal" tabindex="-1" role="dialog" aria-labelledby="deleteMealModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content modal-size-style radius">
            <div class="modal-header">
                <span class="title1  w-100">Please confirm!</span>
                <button type="button" class="close" aria-label="Close" data-bs-dismiss="modal">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body textCenter padding">
                <p class="modalText">Are you sure you want to delete this meal from the plan?</p>
                <p class="modalText mt-2" *ngIf="toDelMealType || toDelMealTime">
                    <strong>Meal:</strong> {{ toDelMealType }}<span *ngIf="toDelMealTime">, Time: {{ toDelMealTime }}</span>
                </p>
                <br />
                <span><button class="btnConfirm btnLabel" (click)="proceedDelMeal()">Proceed</button></span><span>
                    <button class="btnConfirm1 btnLabel1" (click)="closeDelMeal()">Cancel</button> </span>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="checkAssign" tabindex="-1" role="dialog" aria-labelledby="checkAssignLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content modal-size-style radius">
            <div class="modal-header text-center">
                <span class="title1  w-100">Confirm Date</span>
                <button type="button" class="close" aria-label="Close" data-bs-dismiss="modal">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body textCenter">
                <p class="modalText">New Meal Plan: {{this.mealPlanName}}</p>
                <p class="modalSubText">{{this.newMealPlan?.fromDate.split('T')[0]}} -
                    {{this.newMealPlan?.toDate.split('T')[0]}}
                </p>
                <p class="modalText">Existing Meal Plan: {{this.exisitngMealPlanName}}</p>
                <p class="modalSubText">{{this.existingMealPlan?.fromDate.split('T')[0]}} -
                    {{this.existingMealPlan?.toDate.split('T')[0]}}
                </p>
                <p class="modalText">Please select new end date for existing meal plan</p>
                <p><mat-form-field>
                        <mat-label>Pick end date</mat-label>
                        <input matInput [matDatepicker]="picker2" #dateRangeEnd2 [(ngModel)]="currentDate"
                            [min]="minDate" (dateChange)="setMemMealDate(dateRangeEnd2)">
                        <mat-hint>MM/DD/YYYY</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
                        <mat-datepicker #picker2></mat-datepicker>
                    </mat-form-field></p>
                <p class="modalSubText">You End Date will be updated to {{memMealDate}} </p>
                <button class="col-md-2 btn btnSec btnLabel1" (click)="updateAndAssign()">Confirm</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="editMealModal" tabindex="-1" role="dialog" aria-labelledby="editMealModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content modal-size-style radius">
            <div class="modal-header">
                <span class="title1 w-100">Edit Meal</span>
                <button type="button" class="close" aria-label="Close" (click)="closeEditMealModal()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body padding edit-meal-modal-body">
                <div class="row mt-2">
                    <div class="col-md-12">
                        <label class="modalSubText">Meal Type<span class="color">*</span>:</label>
                        <select class="form-control edit-meal-field mt-1" [(ngModel)]="editMealType">
                            <option value="">Select Meal Type</option>
                            <option value="Early morning">Early morning</option>
                            <option value="Breakfast">Breakfast</option>
                            <option value="Mid morning">Mid morning</option>
                            <option value="Lunch">Lunch</option>
                            <option value="Mid evening">Mid evening</option>
                            <option value="Snack">Snack</option>
                            <option value="Dinner">Dinner</option>
                            <option value="Bedtime">Bedtime</option>
                        </select>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-12">
                        <label class="modalSubText">Meal Time<span class="color">*</span>:</label>
                        <input
                            class="form-control edit-meal-field mt-1"
                            type="time"
                            [(ngModel)]="editMealTimeValue"
                            [ngModelOptions]="{standalone: true}"
                            placeholder="Pick Time"
                        />
                    </div>
                </div>
            </div>
            <div class="modal-footer edit-meal-modal-footer">
                <button type="button" class="btn edit-meal-btn-save" (click)="saveMealFromModal()">Save</button>
                <button type="button" class="btn edit-meal-btn-cancel" (click)="closeEditMealModal()">Cancel</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="fastingModal" tabindex="-1" aria- labelledby="fastingModalLabel" data-bs-backdrop="static"
    aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content modal-size-style radius">
            <div class="modal-header">
                <span class="title1">Add Fasting Window</span>
                <button type="button" class="close" aria-label="Close" data-bs-dismiss="modal">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row mt-1">
                    <div class="col modalText">{{fastingDate}}, {{fastingDay}}</div>
                </div>
                <div class="row mt-3">
                    <div class="col-sm">
                        <span class="modalSubText">From Time:</span>
                        <input type="time" [(ngModel)]="fastingStartTime" [ngModelOptions]="{standalone: true}"
                            placeholder="Start Date" class="form-control fastingField" />
                    </div>
                    <div class="col-sm">
                        <span class="modalSubText">To Time:</span>
                        <input type="time" [(ngModel)]="fastingEndTime" [ngModelOptions]="{standalone: true}"
                            placeholder="End Date" class="form-control fastingField" />
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn fastBtn btnLabel1" (click)="saveFastingWindow()">Submit</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="editModal" tabindex="-1" aria- labelledby="editModalLabel" data-bs-backdrop="static"
    aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
        <div class="modal-content modal-size-style radius">
            <div class="modal-header">
                <span class="title1">{{mode==1?'Edit Details':'Details'}}</span>
                <button type="button" class="close" aria-label="Close" data-bs-dismiss="modal">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div *ngIf="editRecipeObj">
                    <div class="row mt-1">
                        <div class="col-md-6">
                            <span class="editSubText">Name</span>
                            <input type="text" [disabled]="mode==0" [(ngModel)]="editRecipeObj.recipeName" class="form-control editField" />
                        </div>
                        <div class="col-md-6">
                            <span class="editSubText">Recipe Type</span>
                            <select [disabled]="mode==0" [(ngModel)]="editRecipeObj.recipeType" class="form-control editField">
                                <option value="DIY">DIY</option>
                                <option value="Packaged">Packaged</option>
                                <option value="Restaurant">Restaurant</option>
                            </select>
                        </div>
                    </div>
                    <div class="row tagsRow">
                        <div class="col-auto">
                            <label class="tagCheckbox" [class.tagCheckbox-checked]="editRecipeObj.isUpf">
                                <input type="checkbox" class="tagCheckbox-input" [disabled]="mode==0" [(ngModel)]="editRecipeObj.isUpf" />
                                <span class="tagCheckbox-label">Is Ultra Processed Food</span>
                                <span class="tagCheckbox-badge"></span>
                            </label>
                        </div>
                        <div class="col-auto">
                            <label class="tagCheckbox" [class.tagCheckbox-checked]="editRecipeObj.isBev">
                                <input type="checkbox" class="tagCheckbox-input" [disabled]="mode==0" [(ngModel)]="editRecipeObj.isBev" />
                                <span class="tagCheckbox-label">Is Beverage</span>
                                <span class="tagCheckbox-badge"></span>
                            </label>
                        </div>
                        <div class="col-auto">
                            <label class="tagCheckbox" [class.tagCheckbox-checked]="editRecipeObj.isAlcoholic">
                                <input type="checkbox" class="tagCheckbox-input" [disabled]="mode==0" [(ngModel)]="editRecipeObj.isAlcoholic" />
                                <span class="tagCheckbox-label">Is Alcoholic</span>
                                <span class="tagCheckbox-badge"></span>
                            </label>
                        </div>
                    </div>
                    <div class="row mt-5 nutritionRow">
                        <div class="col-md-2">
                            <span class="editSubText">Calories (Kcal)</span>
                            <input type="number" [disabled]="mode==0" onkeydown="return event.keyCode !== 69"
                                [(ngModel)]="editRecipeObj.nutrition.calories" class="form-control editField1" />
                        </div>
                        <div class="col-md-2">
                            <span class="editSubText">Protein (grams)</span>
                            <input type="number" [disabled]="mode==0" onkeydown="return event.keyCode !== 69"
                                [(ngModel)]="editRecipeObj.nutrition.protein" (ngModelChange)="onMealMacroChange()" class="form-control editField1" />
                        </div>
                        <div class="col-md-2">
                            <span class="editSubText">Carbs (grams)</span>
                            <input type="number" [disabled]="mode==0" onkeydown="return event.keyCode !== 69"
                                [(ngModel)]="editRecipeObj.nutrition.carbs" (ngModelChange)="onMealMacroChange()" class="form-control editField1" />
                        </div>
                        <div class="col-md-2">
                            <span class="editSubText">Fats (grams)</span>
                            <input type="number" [disabled]="mode==0" onkeydown="return event.keyCode !== 69"
                                [(ngModel)]="editRecipeObj.nutrition.fats" (ngModelChange)="onMealMacroChange()" class="form-control editField1" />
                        </div>
                        <div class="col-md-2">
                            <span class="editSubText">Fiber (grams)</span>
                            <input type="number" [disabled]="mode==0" onkeydown="return event.keyCode !== 69"
                                [(ngModel)]="editRecipeObj.nutrition.fiber" class="form-control editField1" />
                        </div>
                        <div class="col-md-2">
                            <span class="editSubText">Sugar (grams)</span>
                            <input type="number" [disabled]="mode==0" onkeydown="return event.keyCode !== 69"
                                [(ngModel)]="editRecipeObj.nutrition.sugar" class="form-control editField1" />
                        </div>
                        <div class="col-md-2">
                            <span class="editSubText">Alcohol (grams)</span>
                            <input type="number" [disabled]="mode==0" onkeydown="return event.keyCode !== 69"
                                [(ngModel)]="editRecipeObj.nutrition.alcoholGrams" (ngModelChange)="onMealMacroChange()" class="form-control editField1" />
                        </div>
                        <div class="col-md-2">
                            <span class="editSubText">Alcohol ABV (%)</span>
                            <input type="number" [disabled]="mode==0" onkeydown="return event.keyCode !== 69"
                                [(ngModel)]="editRecipeObj.nutrition.alcoholAbv" class="form-control editField1" />
                        </div>
                        <div class="col-md-2">
                            <span class="editSubText">Caffeine (mg)</span>
                            <input type="number" [disabled]="mode==0" onkeydown="return event.keyCode !== 69"
                                [(ngModel)]="editRecipeObj.nutrition.caffeine" class="form-control editField1" />
                        </div>
                    </div>
                    <hr class="sectionDivider" />
                    <div class="row mt-5">
                        <div class="col title1">Ingredients</div>
                    </div>
                    <div class="ingredientBlock mt-3" *ngFor="let ingr of editRecipeObj.ingredients; let i = index">
                        <div class="row">
                            <div class="col-md-3">
                                <span class="editSubText">Name of the Recipe</span>
                                <input type="text" [disabled]="mode==0" [(ngModel)]="ingr.name" class="form-control editField2 ht" />
                            </div>
                            <div class="col-md-2">
                                <span class="editSubText">Serving Size</span>
                                <input type="number" [disabled]="mode==0" onkeydown="return event.keyCode !== 69" [(ngModel)]="ingr.quantity"
                                    class="form-control editField1 ht" />
                            </div>
                            <div class="col-md-2">
                                <span class="editSubText">Serving Unit</span>
                                <select [disabled]="mode==0" [(ngModel)]="ingr.unit" class="form-control editField1 ht">
                                    <option value="grams">grams</option>
                                    <option value="ounces">ounces</option>
                                    <option value="fluid ounces">fluid ounces</option>
                                    <option value="cups">cups</option>
                                </select>
                            </div>
                            <div class="col-md-2">
                                <span class="editSubText">Servings</span>
                                <input type="number" [disabled]="mode==0" onkeydown="return event.keyCode !== 69" [(ngModel)]="ingr.servings"
                                    class="form-control editField1 ht" />
                            </div>
                        </div>
                        <div class="row tagsRow">
                            <div class="col-auto">
                                <label class="tagCheckbox" [class.tagCheckbox-checked]="ingr.isUpf">
                                    <input type="checkbox" class="tagCheckbox-input" [disabled]="mode==0" [(ngModel)]="ingr.isUpf" />
                                    <span class="tagCheckbox-label">Is Ultra Processed Food</span>
                                    <span class="tagCheckbox-badge"></span>
                                </label>
                            </div>
                            <div class="col-auto">
                                <label class="tagCheckbox" [class.tagCheckbox-checked]="ingr.isBev">
                                    <input type="checkbox" class="tagCheckbox-input" [disabled]="mode==0" [(ngModel)]="ingr.isBev" />
                                    <span class="tagCheckbox-label">Is Beverage</span>
                                    <span class="tagCheckbox-badge"></span>
                                </label>
                            </div>
                            <div class="col-auto">
                                <label class="tagCheckbox" [class.tagCheckbox-checked]="ingr.isAlcoholic">
                                    <input type="checkbox" class="tagCheckbox-input" [disabled]="mode==0" [(ngModel)]="ingr.isAlcoholic" />
                                    <span class="tagCheckbox-label">Is Alcoholic</span>
                                    <span class="tagCheckbox-badge"></span>
                                </label>
                            </div>
                        </div>
                        <div class="row mt-4 nutritionRow">
                            <div class="col-md-2">
                                <span class="editSubText">Calories (Kcal)</span>
                                <input type="number" [disabled]="mode==0" onkeydown="return event.keyCode !== 69"
                                    [(ngModel)]="ingr.nutrition.calories" (ngModelChange)="recalculateRecipeNutrition()" class="form-control editField1" />
                            </div>
                            <div class="col-md-2">
                                <span class="editSubText">Protein (grams)</span>
                                <input type="number" [disabled]="mode==0" onkeydown="return event.keyCode !== 69"
                                    [(ngModel)]="ingr.nutrition.protein" (ngModelChange)="onIngredientMacroChange(ingr)" class="form-control editField1" />
                            </div>
                            <div class="col-md-2">
                                <span class="editSubText">Carbs (grams)</span>
                                <input type="number" [disabled]="mode==0" onkeydown="return event.keyCode !== 69"
                                    [(ngModel)]="ingr.nutrition.carbs" (ngModelChange)="onIngredientMacroChange(ingr)" class="form-control editField1" />
                            </div>
                            <div class="col-md-2">
                                <span class="editSubText">Fats (grams)</span>
                                <input type="number" [disabled]="mode==0" onkeydown="return event.keyCode !== 69"
                                    [(ngModel)]="ingr.nutrition.fat" (ngModelChange)="onIngredientMacroChange(ingr)" class="form-control editField1" />
                            </div>
                            <div class="col-md-2">
                                <span class="editSubText">Fiber (grams)</span>
                                <input type="number" [disabled]="mode==0" onkeydown="return event.keyCode !== 69"
                                    [(ngModel)]="ingr.nutrition.fiber" (ngModelChange)="recalculateRecipeNutrition()" class="form-control editField1" />
                            </div>
                            <div class="col-md-2">
                                <span class="editSubText">Sugar (grams)</span>
                                <input type="number" [disabled]="mode==0" onkeydown="return event.keyCode !== 69"
                                    [(ngModel)]="ingr.nutrition.sugar" (ngModelChange)="recalculateRecipeNutrition()" class="form-control editField1" />
                            </div>
                            <div class="col-md-2">
                                <span class="editSubText">Alcohol (grams)</span>
                                <input type="number" [disabled]="mode==0" onkeydown="return event.keyCode !== 69"
                                    [(ngModel)]="ingr.nutrition.alcoholGrams" (ngModelChange)="onIngredientMacroChange(ingr)" class="form-control editField1" />
                            </div>
                            <div class="col-md-2">
                                <span class="editSubText">Alcohol ABV (%)</span>
                                <input type="number" [disabled]="mode==0" onkeydown="return event.keyCode !== 69"
                                    [(ngModel)]="ingr.nutrition.alcoholAbv" (ngModelChange)="recalculateRecipeNutrition()" class="form-control editField1" />
                            </div>
                            <div class="col-md-2">
                                <span class="editSubText">Caffeine (mg)</span>
                                <input type="number" [disabled]="mode==0" onkeydown="return event.keyCode !== 69"
                                    [(ngModel)]="ingr.nutrition.caffeine" (ngModelChange)="recalculateRecipeNutrition()" class="form-control editField1" />
                            </div>
                        </div>
                        <img class="ingredientDeleteBtn" *ngIf="mode==1" src="assets/img/minus.png" width="30" (click)="deleteIngr(i)" />
                    </div>
                    <div class="row mt-4" *ngIf="mode==1">
                        <div class="col">
                            <img src="assets/img/plus.png" width="30" (click)="addIngr()" style="cursor: pointer;" />
                        </div>
                    </div>
                    <div *ngIf="editRecipeObj.recipeType == 'Packaged'">
                        <div class="row mt-4">
                            <div class="col-md-12 title1">
                                Brand details
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-md-3">
                                <span class="editSubText">Name</span>
                                <input type="text" [disabled]="mode==0" [(ngModel)]="editRecipeObj.brand.brandName"
                                    class="form-control editField2" />
                            </div>
                            <div class="col-md-6">
                                <span class="editSubText">Barcode</span>
                                <input type="text" [disabled]="mode==0" [(ngModel)]="editRecipeObj.brand.barCode"
                                    class="form-control editField2" />
                            </div>
                        </div>
                        <div class="row mt-5">
                            <div class="col-md-12 title1">
                                Available in
                            </div>
                        </div>
                        <div class="row mt-2" *ngFor="let store of editRecipeObj.stores;let i=index">
                            <div class="col-md-3">
                                <span class="editSubText">Name</span>
                                <input type="text" [disabled]="mode==0"  [(ngModel)]="store.storeName" class="form-control editField4" />
                            </div>
                            <div class="col-md-4">
                                <span class="editSubText">Location</span>
                                <input type="text" [disabled]="mode==0"  [(ngModel)]="store.location" class="form-control editField4" />
                            </div>
                            <div class="col-md-4">
                                <span class="editSubText">Website</span>
                                <input type="text" [disabled]="mode==0"  [(ngModel)]="store.website" class="form-control editField4" />
                                <span *ngIf="mode==1"><img src="assets/img/minus.png" width="30" (click)="deleteStore(i)"
                                        style="margin-left: 285px;margin-top: -80px;cursor: pointer;" /></span>
                            </div>
                        </div>

                        <div class="row mt-1" *ngIf="mode==1">
                            <div class="col">
                                <img src="assets/img/plus.png" width="30" (click)="addStore()"
                                    style="cursor: pointer;" />
                            </div>
                        </div>
                    </div>
                    <div *ngIf="editRecipeObj.recipeType == 'DIY' || editRecipeObj.recipeType == 'FreshProduce'">
                        <div class="row mt-4">
                            <div class="col-md-12 mt-2 title1">
                                Cooking Methods
                            </div>
                        </div>
                        <div class="row" *ngFor="let method of editRecipeObj.cookingMethods;let i=index">
                            <div class="col-md-8">
                                <input type="text" [disabled]="mode==0" [(ngModel)]="method.method" class="form-control editField2" />
                                <span *ngIf="mode==1"><img src="assets/img/minus.png" width="30" (click)="deleteMethod(i)"
                                        style="margin-left: 680px;margin-top: -77px;cursor: pointer;" /></span>
                            </div>
                        </div>
                        <div class="row" *ngIf="mode==1">
                            <div class="col">
                                <img src="assets/img/plus.png" width="30" (click)="addMethod()"
                                    style="cursor: pointer;" />
                            </div>
                        </div>
                    </div>
                    <div *ngIf="editRecipeObj.recipeType == 'Restaurant'">
                        <div class="row mt-4">
                            <div class="col-md-12 title1">
                                Restaurant Details
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-md-6">
                                <span class="editSubText">Name</span>
                                <input type="text" [disabled]="mode==0"  [(ngModel)]="editRecipeObj.restaurant.name"
                                    class="form-control editField2" />
                            </div>
                            <div class="col-md-6">
                                <span class="editSubText">Location</span>
                                <input type="text" [disabled]="mode==0"  [(ngModel)]="editRecipeObj.restaurant.location"
                                    class="form-control editField2" />
                            </div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-md-6">
                                <span class="editSubText">Website</span>
                                <input type="text" [disabled]="mode==0"  [(ngModel)]="editRecipeObj.restaurant.website"
                                    class="form-control editField2" />
                            </div>
                            <div class="col-md-6">
                                <span class="editSubText">Phone Number</span>
                                <input type="text" [disabled]="mode==0"  [(ngModel)]="editRecipeObj.restaurant.phoneNumber"
                                    class="form-control editField2" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button *ngIf="mode==1" class="btn fastBtn btnLabel1" (click)="updateRecipe()">Save Changes</button>
                <button *ngIf="mode==0" class="btn fastBtn btnLabel1" (click)="closeEditModal()">Close</button>
            </div>
        </div>
    </div>
</div>